import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as api_general from '../api/General.ts';
import * as user_functions from '../misc/UserFunctions.ts';

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

export function LogonPage() {
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [message, setMessage] = React.useState<string>('');
    const [loggingOn, setLoggingOn] = React.useState<boolean>(false);
    const navigate = useNavigate();
    const [forgotPass, setForgotPass] = React.useState<boolean>(false);

    const handleLogon = async () => {

        try {
            setLoggingOn(true);
            const user = await api_general.getUserAndToken(username, password);
            user_functions.setLoggedInUser(user.full_name, user.access_token, user.role);

            window.location.href = '/dashboard'; //NOTE: navigate('/dashboard') does not work here

        } catch (error) {
            setMessage(error.message); //TODO: improve error message

        } finally {
            setLoggingOn(false);
        }
    }

    return (
        <div style={{ textAlign: 'center' }}>
            <h1>FRAC Resistance Database</h1>

            Username: <TextField
                id="username"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)} />
            <br />

            {forgotPass &&
                <>
                    <br />
                    <Button variant="contained" >Send reset email...</Button>
                </>
            }



            {!forgotPass &&
                <>
                    {/* <a href="#" onClick={() => setForgotPass(true)}>Click if you forgot your password.</a> */}

                    <br />
                    <br />
                    Password: <TextField id="password" variant="outlined" type="password" value={password} onChange={(e) => setPassword(e.target.value)} /><br />

                    <br />
                    {
                        !loggingOn &&
                        <Button variant="contained" onClick={handleLogon}>Logon</Button>
                    }

                    {
                        loggingOn &&
                        <Button variant="contained" disabled>Please wait...</Button>
                    }

                    <div>{message}</div>
                </>
            }

        </div >
    );

}


